import React from 'react';
import { PRICE } from '../data/salesContent';
export function PriceBlock({
  lead
}: {
  lead?: string;
}) {
  return <div className="text-center" data-id="element-32" data-mp="1yua13qbhitsl">
      {lead && <p className="text-base font-bold uppercase tracking-[0.2em] text-neutral-400 md:text-lg" data-id="element-33" data-mp="1yxo14rwoeqwv">{lead}</p>}
      <p className="mt-1 font-display text-5xl font-black text-gold md:text-6xl" data-id="element-34" data-mp="27w01hlnch32i">{PRICE}</p>
      <p className="mt-3 text-base text-neutral-300 md:text-lg" data-id="element-35" data-mp="27u6ta1x32ase">Pago único · Acceso digital inmediato</p>
    </div>;
}